import { SvgIconProps } from "@mui/material";
import React from "react";

const EventIcon = (props: SvgIconProps) => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<path d="M6.6665 1.6665V4.99984" stroke={props.stroke || "#0A111D"} stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M13.3335 1.6665V4.99984" stroke={props.stroke || "#0A111D"} stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M4.16667 3.3335H15.8333C16.7538 3.3335 17.5 4.07969 17.5 5.00016V16.6668C17.5 17.5873 16.7538 18.3335 15.8333 18.3335H4.16667C3.24619 18.3335 2.5 17.5873 2.5 16.6668V5.00016C2.5 4.07969 3.24619 3.3335 4.16667 3.3335V3.3335" stroke={props.stroke || "#0A111D"} stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M2.5 8.3335H17.5" stroke={props.stroke || "#0A111D"} stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

    );
};

export default EventIcon;